var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFamilyOffices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 140,
    viewBox: "0 0 154 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_437_2527",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 154,
    height: 140
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 140,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_437_2527)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.75 30.668V33.3379H40.25V33.2698L39.4998 32.0336L41.75 30.668ZM35.0553 34.7308L37.2776 33.3822L38.0558 34.6645L35.8335 36.0131L35.0553 34.7308ZM41.75 36.0129V38.6879H40.25V36.0129H41.75ZM30.6109 37.428L32.8331 36.0794L33.6113 37.3617L31.3891 38.7103L30.6109 37.428ZM26.1664 40.1252L28.3887 38.7766L29.1669 40.0589L26.9447 41.4075L26.1664 40.1252ZM41.75 41.3629V44.0379H40.25V41.3629H41.75ZM21.722 42.8224L23.9442 41.4738L24.7224 42.7561L22.5002 44.1047L21.722 42.8224ZM17.2776 45.5196L19.4998 44.171L20.278 45.4533L18.0558 46.8019L17.2776 45.5196ZM41.75 46.7129V49.3879H40.25V46.7129H41.75ZM12.8331 48.2168L15.0553 46.8682L15.8335 48.1505L13.6113 49.4991L12.8331 48.2168ZM8.38867 50.914L10.6109 49.5654L11.3891 50.8477L9.16688 52.1963L8.38867 50.914ZM41.75 52.0629V54.7379H40.25V52.0629H41.75ZM3.94422 53.6112L6.16645 52.2626L6.94466 53.5449L4.72244 54.8935L3.94422 53.6112ZM1.722 54.9598L2.50021 56.2421L1.75 56.6974V57.5678H0.25V55.8531L1.722 54.9598ZM41.75 57.4129V60.0879H40.25V57.4129H41.75ZM0.25 62.7381V60.153H1.75V62.7381H0.25ZM41.75 62.7629V65.4379H40.25V62.7629H41.75ZM0.25 67.9085V65.3233H1.75V67.9085H0.25ZM41.75 68.1129V70.7879H40.25V68.1129H41.75ZM0.25 73.0788V70.4936H1.75V73.0788H0.25ZM41.75 73.4629V76.1379H40.25V73.4629H41.75ZM0.25 78.2491V75.664H1.75V78.2491H0.25ZM41.75 78.8129V81.4879H40.25V78.8129H41.75ZM0.25 83.4194V80.8343H1.75V83.4194H0.25ZM41.75 84.1629V86.8379H40.25V84.1629H41.75ZM0.25 88.5898V86.0046H1.75V88.5898H0.25ZM41.75 89.5129V92.1879H40.25V89.5129H41.75ZM0.25 93.7601V91.1749H1.75V93.7601H0.25ZM41.75 94.8629V97.5379H40.25V94.8629H41.75ZM0.25 98.9304V96.3453H1.75V98.9304H0.25ZM41.75 100.213V102.888H40.25V100.213H41.75ZM0.25 104.101V101.516H1.75V104.101H0.25ZM41.75 105.563V108.238H40.25V105.563H41.75ZM0.25 109.271V106.686H1.75V109.271H0.25ZM41.75 110.913V113.588H40.25V110.913H41.75ZM0.25 114.441V111.856H1.75V114.441H0.25ZM41.75 116.263V118.938H40.25V116.263H41.75ZM0.25 119.612V117.027H1.75V119.612H0.25ZM41.75 121.613V124.288H40.25V121.613H41.75ZM0.25 124.782V122.197H1.75V124.782H0.25ZM41.75 126.963V129.638H40.25V126.963H41.75ZM0.25 129.952V127.367H1.75V129.952H0.25ZM41.75 132.313V134.988H40.25V132.313H41.75ZM0.25 135.123V132.538H1.75V135.123H0.25ZM41.75 137.663V139.75H39.75V138.25H40.25V137.663H41.75ZM0.25 137.708H1.75V138.25H2.25V139.75H0.25V137.708ZM7.25 139.75H4.75V138.25H7.25V139.75ZM12.25 139.75H9.75V138.25H12.25V139.75ZM17.25 139.75H14.75V138.25H17.25V139.75ZM22.25 139.75H19.75V138.25H22.25V139.75ZM27.25 139.75H24.75V138.25H27.25V139.75ZM32.25 139.75H29.75V138.25H32.25V139.75ZM37.25 139.75H34.75V138.25H37.25V139.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 5L94 23V139H35V5Z",
    fill: "#FAFAFA",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3506 102.376C87.3506 98.3719 90.5966 95.126 94.6006 95.126C98.6047 95.126 101.851 98.3719 101.851 102.376V121.001H87.3506V102.376Z",
    fill: "#FAFAFA",
    stroke: "#304FF2",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.5986,
    cy: 122.501,
    r: 17.5,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5971 116L94.5971 130",
    stroke: "#FAFAFA",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.009 82.3193C104.407 66.1664 117.626 53.1943 133.875 53.1943H152.366C151.968 69.3473 138.749 82.3193 122.5 82.3193H104.009Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.009 82.3193C104.407 66.1664 117.626 53.1943 133.875 53.1943H152.366C151.968 69.3473 138.749 82.3193 122.5 82.3193H104.009Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.009 82.3193C104.407 66.1664 117.626 53.1943 133.875 53.1943H152.366C151.968 69.3473 138.749 82.3193 122.5 82.3193H104.009Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.23 55.1943C110.84 47.742 104.674 41.8193 97.1248 41.8193H89.1443C89.5342 49.2717 95.7003 55.1943 103.25 55.1943H111.23Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.23 55.1943C110.84 47.742 104.674 41.8193 97.1248 41.8193H89.1443C89.5342 49.2717 95.7003 55.1943 103.25 55.1943H111.23Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.23 55.1943C110.84 47.742 104.674 41.8193 97.1248 41.8193H89.1443C89.5342 49.2717 95.7003 55.1943 103.25 55.1943H111.23Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1248 68.1943H65.6248",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1248 50.6943H65.6248",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1248 33.1943H65.6248",
    stroke: "black",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyOffices);
export default __webpack_public_path__ + "static/media/family_offices.95b2da5d1bafef2eeaeb21be92be4633.svg";
export { ForwardRef as ReactComponent };